import { AccountLimits } from 'app/account/account.model';
import { GET_LIMITS_SUCCESS, LimitsActions } from 'app/shared/limits/limits.actions';
import { createSelector } from 'reselect';

export type LimitsState = AccountLimits;
export const initialState: LimitsState = {};

export function limitsReducer(state: LimitsState = initialState, action: LimitsActions): LimitsState {
  switch (action.type) {
    case GET_LIMITS_SUCCESS:
      return { ...state, ...action.payload };
    default: {
      return state;
    }
  }
}

const rootSelector = state => state.limits;

export const getLimitsSelector = createSelector(rootSelector, a => a);
